import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import { JPYs, secondsToHms } from '../common/Common';
import { useEffect, useState } from 'react';
import { FRBend } from '../common/Constant';

const IQ3KouteiBetsuKesanshiki_Bending = (props) => {
  const [isDantoriOpen, setIsDantoriOpen] = useState(true);
  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  const [bendProcessInput, setBendProcessInput] = useState([]);

  const mSetHRate = props?.deviceMst?.details?.charges?.prep || 0;
  //装置の作業時間チャージ
  const mSagyoHRate = props?.deviceMst?.details?.charges?.work;

  // 曲長段取時間
  const prepBendTimeLengthMaster = props?.deviceMst?.details?.prepBendTimeLengthMaster?.filter(
    (item) =>
      (item.value == Number(bendProcessInput?.details?.[0]?.bendingData?.maxBendLength) ||
        item.value > Number(bendProcessInput?.details?.[0]?.bendingData?.maxBendLength)) &&
      !item.isOutOfRange
  );

  const mageDandoriTime = props?.deviceMst?.details?.prepBendTimeItems?.filter(
    (item) => item.no == prepBendTimeLengthMaster?.[0]?.no
  )?.[0]?.value;

  const mageDandoriAmt = (mageDandoriTime * mSetHRate) / 3600;

  useEffect(() => {
    // ベンディング工程入力情報取得
    let bendingProcessInput = props?.bendData?.processInput?.filter(
      (item) => item.processId == props?.processMst?.id
    )[0];
    if (bendingProcessInput) {
      setBendProcessInput(bendingProcessInput);
    }
  }, [props?.bendData]);

  const dantoriOpen = () => {
    if (isDantoriOpen) {
      setIsDantoriOpen(false);
    } else {
      setIsDantoriOpen(true);
    }
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };

  const toggleInputSubDetail = (parentKey, index) => {
    const key = `${parentKey}-${index}`; // Example: "dantori-0"

    setOpenInputSubDetailKeys((prevKeys) => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key); // Close it
      } else {
        newKeys.add(key); // Open it
      }
      return newKeys;
    });
  };

  const calDandoriTime = (deviceMst, magesu, typeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 段取時間設定
    let basicTimeThickThMaster = deviceMst?.details?.basicTimeThickThMaster?.filter(
      (item) => (item.value == magesu || item.value > magesu) && !item.isOutOfRange
    );

    let basicTimeThickItems = Object.entries(deviceMst?.details?.basicTimeThickItems)?.filter(
      ([key, data]) => parseInt(key) === typeId && !data.isOutOfRange
    )?.[0];
    let deviceDandori = [];
    basicTimeThickItems?.map((item, index) => {
      if (index > 0) {
        deviceDandori = item;
      }
    });
    //　基本段取時間
    // let dandoriTimeSec =
    //   deviceDandori?.filter((item) => item.no == basicTimeThickThMaster?.[0]?.no && !item.isOutOfRange)?.[0]?.value *
    //   sizeCoef;
    let dandoriTimeSec = deviceDandori?.filter(
      (item) => item.no == basicTimeThickThMaster?.[0]?.no && !item.isOutOfRange
    )?.[0]?.value;
    dandoriTimeSec = dandoriTimeSec ? dandoriTimeSec : 0;
    //dandoriTimeSec = dandoriTimeSec * getSetupCoeff(deviceMst); // IQX_WEBEST-278 基本段取時間＊段取個数係数
    return dandoriTimeSec;
  };

  const getSagyoTime = (deviceMst, thickness, typeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 段取時間設定
    let workTimeThickThMaster = deviceMst?.details?.workTimeThickThMaster?.filter(
      (item) => item.value == thickness || item.value > thickness
    );

    let workTimeThickItems = Object.entries(deviceMst?.details?.workTimeThickItems)?.filter(
      ([key, data]) => parseInt(key) === typeId
    )?.[0];
    let deviceWorkTime = [];
    workTimeThickItems?.map((item, index) => {
      if (index > 0) {
        deviceWorkTime = item;
      }
    });
    //　基本段取時間
    let deviceWorkTimeSec = deviceWorkTime?.filter((item) => item.no == workTimeThickThMaster?.[0]?.no)?.[0]?.value;
    deviceWorkTimeSec = deviceWorkTimeSec ? deviceWorkTimeSec : 0;
    return deviceWorkTimeSec;
  };

  const getBendingCoeff = (deviceMst, weight, area) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 段取時間設定

    // kg
    let bendTimeCoeffWeightThMaster = deviceMst?.details?.bendTimeCoeffWeightThMaster?.filter(
      (item) => (item.value == weight || item.value > weight) && !item.isOutOfRange
    );
    // mm
    let bendTimeCoeffLenThMaster = deviceMst?.details?.bendTimeCoeffLenThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item.isOutOfRange
    );
    let childPartsCoeffs =
      bendTimeCoeffWeightThMaster?.length > 0 && bendTimeCoeffLenThMaster?.length > 0
        ? deviceMst?.details?.bendTimeCoeffWeightLenItems?.filter(
            (item) => item.weightId == bendTimeCoeffWeightThMaster[0]?.no
          )
        : deviceMst?.details?.bendTimeCoeffWeightLenItems[0];

    // 曲げ長さ係数
    let partsCoeff =
      childPartsCoeffs?.length > 0
        ? childPartsCoeffs?.[0]?.lengthCoeffList?.filter(
            (item) => item.no == bendTimeCoeffLenThMaster?.[0]?.no && !item.isOutOfRange
          )?.[0]?.value
        : childPartsCoeffs?.[0]?.lengthCoeffList?.[0]?.value;
    partsCoeff = partsCoeff ? partsCoeff : 0;
    return partsCoeff;
  };

  const getBendingModifyCoeff = (deviceMst, weight, area) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 重量
    let modifyCoeffWeightThMaster = deviceMst?.details?.modifyCoeffWeightThMaster?.filter(
      (item) => (item.value == weight || item.value > weight) && !item.isOutOfRange
    );
    // 面積
    let modifyCoeffLenThMaster = deviceMst?.details?.modifyCoeffLenThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item.isOutOfRange
    );
    let childPartsCoeffs =
      modifyCoeffWeightThMaster?.length > 0 && modifyCoeffLenThMaster?.length > 0
        ? deviceMst?.details?.modifyCoeffItems?.filter((item) => item.weightId == modifyCoeffWeightThMaster[0]?.no)
        : deviceMst?.details?.modifyCoeffItems[0];

    // 補正係数
    let partsCoeff =
      childPartsCoeffs?.length > 0
        ? childPartsCoeffs?.[0]?.lengthCoeffList?.filter(
            (item) => item.no == modifyCoeffLenThMaster?.[0]?.no && !item.isOutOfRange
          )?.[0]?.value
        : childPartsCoeffs?.[0]?.lengthCoeffList?.[0]?.value;
    partsCoeff = partsCoeff ? partsCoeff : 0;
    return partsCoeff;
  };

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.selectedEstimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.selectedIQ3DataDetail?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      {/* SECTION 1: 段取金額/時間 (Setup) */}
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}
        onClick={() => dantoriOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isDantoriOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'段取金額/時間'}</label>
        </Col>
      </Row>

      <div style={{ display: isDantoriOpen ? 'block' : 'none', marginLeft: 10 }}>
        {bendProcessInput?.details?.[0]?.bendingList?.length > 0 ? (
          bendProcessInput.details[0].bendingList.map((process, index) => {
            // 1. Data Prep
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == process.types)?.name || '不明';
            const detailKey = `dantori-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            const dandoriTimeSec = calDandoriTime(props?.deviceMst, process.lines, process.types) || 0;

            const dandoriAmt = (dandoriTimeSec * mSetHRate) / 3600;

            return (
              <div key={`dantori-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('dantori-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取金額'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div>
                            <label>{'曲げ_段取時間'}</label>
                          </div>

                          <div>
                            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div>
                            <label>{`${dandoriTimeSec} (${secondsToHms(dandoriTimeSec)})`}</label>
                          </div>

                          <div>
                            <label>{`${dandoriTimeSec} × ${mSetHRate} = ${JPYs.format(Math.round(dandoriAmt))}`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '2px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 30, paddingTop: 10 }}>
                <div>
                  <label>{'曲長段取時間'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div>
                  <label>{'曲げ_段取時間'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${mageDandoriTime}`}</label>
                </div>
              </Col>
            </Row>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 30, paddingTop: 10 }}>
                <div>
                  <label>{'曲長段取金額'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div>
                  <label>{'曲長段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${mageDandoriTime} × ${mSetHRate} = ${JPYs.format(Math.round(mageDandoriAmt))}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* SECTION 2: 加工金額/時間 (Work) */}
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => kakouOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isKakouOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        {bendProcessInput?.details?.[0]?.bendingList?.length > 0 ? (
          bendProcessInput.details[0].bendingList.map((process, index) => {
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == process.types)?.name || '不明';
            const detailKey = `kakou-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            // 曲げ回数判断(IQX_WEBEST-196)
            let bendingCount = 1;
            let bendingModifyCount = 1;
            props?.processMst?.details?.processDetailTypes
              ?.filter((item) => item.name.includes(FRBend))
              ?.map((item) => {
                //FR曲げの場合、FR曲げ回数を取得
                if (item.id === process?.types) {
                  bendingCount = process?.bendCount; // FR曲げ回数
                } else {
                  bendingCount = process?.lines; // 曲げ回数
                  bendingModifyCount = process?.lines; // 曲げ回数
                }
              });
            bendingCount = bendingCount ? Number(bendingCount) : 1;

            // 板厚
            const thickness = props?.parameters?.materialIq3?.filter(
              (item) => item.id == props?.bendData?.thickness
            )?.[0]?.info?.thick;
            // 重量
            const weight = props?.bendData?.weight;

            // 最大曲げ線長
            const maxBendLen = bendProcessInput?.details?.[0]?.bendingData?.maxBendLength;

            const bendingCoef = getBendingCoeff(props?.deviceMst, weight, maxBendLen);
            // 曲げ補正時間係数
            const bendingModifyCoef = getBendingModifyCoeff(props?.deviceMst, weight, maxBendLen);
            const sagyoTimePerPartCntSec = getSagyoTime(props?.deviceMst, thickness, process.types);
            const productionQuantityCoeff = getProductionQuantityCoeff(props?.deviceMst);

            //(1つ当たりの加工時間	*	曲げ長さ係数)
            const sagyoBendCoef = sagyoTimePerPartCntSec * bendingCoef * bendingCount;
            let totalSagyoTimeSec = 0;

            const insuu = props?.bendData?.partCount;

            let bendingModifyTime = 1;

            //員数によって作業時間取得
            for (let i = 1; i <= insuu; i++) {
              // 曲げ補正時間
              const modifyTimeQtyThMaster = props?.deviceMst?.details?.modifyTimeQtyThMaster?.filter(
                (item) => (item.value == i || item.value > i) && !item.isOutOfRange
              );
              bendingModifyTime = props?.deviceMst?.details?.modifyTimeItems?.filter(
                (item) => item.no == modifyTimeQtyThMaster?.[0]?.no && !item.isOutOfRange
              )?.[0]?.value;

              // 作業時間（{(1つ当たりの加工時間	*	曲げ長さ係数)	+	(曲げ補正時間	*	曲げ補正係数)｝	*	曲げ回数	*	サイズ係数）
              //(曲げ補正時間	*	曲げ補正係数)
              const multiModify = bendingModifyTime * bendingModifyCoef * productionQuantityCoeff;
              totalSagyoTimeSec += sagyoBendCoef + multiModify * bendingModifyCount;
            }

            const sagyoTimeSec = Number.isFinite(totalSagyoTimeSec / insuu) ? totalSagyoTimeSec / insuu : 0;

            // 1つ当たりの加工時間
            const sagyoTimePerSec = Number.isFinite(sagyoTimeSec / bendingCount) ? sagyoTimeSec / bendingCount : 0;

            const sagyoAmt = (sagyoTimeSec * mSagyoHRate) / 3600.0;

            return (
              <div key={`kakou-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('kakou-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '2px solid #eeebeb', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <Typography.Text
                              ellipsis={{
                                tooltip: '加工時間',
                              }}
                            >
                              {'加工時間'}
                            </Typography.Text>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工金額'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'曲数'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'1つ当たりの加工時間'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <Typography.Text
                              ellipsis={{
                                tooltip:
                                  '(((1つ当たりの加工時間 x 曲げ長さ係数 x 曲げ回数) + (曲げ補正時間 x 曲げ補正係数 x 生産個数係数)) x 曲げ回数係数 )',
                              }}
                            >
                              {
                                '(((1つ当たりの加工時間 x 曲げ長さ係数 x 曲げ回数) + (曲げ補正時間 x 曲げ補正係数 x 生産個数係数)) x 曲げ回数係数 )'
                              }
                            </Typography.Text>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'曲数'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'1つ当たりの加工時間'}</label>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <Typography.Text
                              ellipsis={{
                                tooltip: `(((${sagyoTimePerPartCntSec} x ${bendingCoef} x ${bendingCount}) + (${bendingModifyTime} x ${bendingModifyCoef} x ${productionQuantityCoeff})) x ${bendingModifyCount}) = ${sagyoTimeSec} (${secondsToHms(
                                  sagyoTimeSec
                                )})`,
                              }}
                            >
                              {`(((${sagyoTimePerPartCntSec} x ${bendingCoef} x ${bendingCount}) + (${bendingModifyTime} x ${bendingModifyCoef} x ${productionQuantityCoeff})) x ${bendingModifyCount}) = ${sagyoTimeSec} (${secondsToHms(
                                sagyoTimeSec
                              )})`}
                            </Typography.Text>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${sagyoTimeSec} × ${mSagyoHRate} = ${JPYs.format(Math.round(sagyoAmt))}`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${bendingCount}`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${sagyoTimePerSec} (${secondsToHms(sagyoTimePerSec)})`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
      </div>
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_Bending;
